import {
  CANDIDATE_EDUCATION_UPDATE_REQUEST,
  CANDIDATE_EDUCATION_UPDATE_SUCCESS,
  CANDIDATE_EDUCATION_UPDATE_FAIL,
} from "../constants/AuthConstant";

import axios from "axios";
import { toast } from "react-toastify";

export const CandidateEducationAction = (data, navigate) => {
  return async (dispatch) => {
    dispatch({
      type: CANDIDATE_EDUCATION_UPDATE_REQUEST,
      payload: true,
    });

    const token = localStorage.getItem("token");

    try {
      const OPTION = {
        url: `${process.env.REACT_APP_API_PATH}/ebench/add_multiple_education`,
        method: "POST",
        data: data,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const res = await axios(OPTION);

      dispatch(updateDashboardContentPre(res.data));

      toast.success("Updated Successfully!");

      setTimeout(() => {
        navigate("/candidate_dashboard");
      }, 1400);

      return res.data;
    } catch (error) {
      console.error("Education update error:", error);

      const message =
        error.response?.data?.status?.message ||
        "Failed to update education details!";

      toast.error(message);

      dispatch({
        type: CANDIDATE_EDUCATION_UPDATE_FAIL,
        payload: false,
        error: message,
        msg: "Failed to load the information",
      });

      throw error;
    }
  };
};

export const updateDashboardContentPre = (data) => {
  return {
    type: CANDIDATE_EDUCATION_UPDATE_SUCCESS,
    result: data,
    payload: false,
    msg: "SUCCESS",
  };
};
